<template lang="pug">
div.my-2
  v-row(dense align="center")
    //- Details
    v-col(cols="6")
      div.text-sm.neutral700--text {{ servicesName }}
      .d-flex.align-center.mt-1
        v-avatar.mr-1(color="neutral300" size="16" rounded="circle")
          v-img(v-if="apptSession.provider.profile_image" width="16" height="16" :src="apptSession.provider.profile_image.file")
          v-icon(v-else size="16") $yzi-user-03
        div.text-xs {{ apptSession.provider.name }}
    //- Date
    v-col(cols="3")
      set-appointment-date(v-model="selectedDate" placeholder="Select date" hide-details="true" :required="false" :loading="isFetchingTimes" disabled)
    //- Time
    v-col(cols="3")
      y-select(v-model="selectedTime" :items="times" item-text="text" item-value="value" placeholder="Select time" :rules="!selectedDate ? [] : rules.not_empty_select" :loading="isFetchingTimes" :hide-details="true" no-data-text="No timeslot available" @change="setTime(selectedTime)")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import SetAppointmentDate from '@/components/clinic/appointment/advance/SetAppointmentDate.vue'

export default {
  components: { SetAppointmentDate },
  props: {
    session: {
      required: true,
      type: Object,
      default: (() => {})
    },
  },
  data () {
    return {
      isFetchingDates: false,
      isFetchingTimes: false,
      selectedDate: null,
      selectedTime: null,
      times: [],
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  mounted () {
    this.setData()
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    apptSession: {
      get () {
        return this.session
      },
      set (val) {
        this.$emit('update:session', val)
      }
    },
    servicesName () {
      return this.apptSession?.services.map(service => service.name).join(', ')
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    async setData () {
      if (this.apptSession) {
        if (this.apptSession.start) {
          this.selectedDate = this.apptSession.start.substr(0, 10)
          const time = DateTime.fromISO(this.apptSession.start)
          this.selectedTime = time.toFormat('HH:mm:ss')
          const timeData = {
            text: time.toFormat('h:mm a'),
            value: this.selectedTime, 
          }
          this.times = [timeData]
        } else if (this.apptSession.preset_date) {
          await this.fetchTimes(this.apptSession.preset_date)
          this.selectedDate = this.apptSession.preset_date
        }
      }
    },
    fetchTimes (date, clearTime) {
      if (clearTime) {
        this.setDate(date)
      }
      this.isFetchingTimes = true
      let params = {
        services: this.apptSession.services.map(m => m.id).join() || null,
        date: date || null
      }
      return this.$axios.get(`/clinics/${this.company.slug}/providers/${this.apptSession.provider.id}/available_times`, { params })
        .then((resp) => {
          this.times = resp.data.times.map(m => { return { text: this.$options.filters.displayTime2(m), value: m } })
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isFetchingTimes = false
        })
    },
    setDate (date) {
      this.selectedTime = null
      if (date) {
        this.$set(this.apptSession, 'preset_date', date)
      } else {
        this.$set(this.apptSession, 'start', null)
        this.$set(this.apptSession, 'preset_date', null)
      }
    },
    async setTime (time) {
      const start = `${this.selectedDate} ${time}`
      try {
        this.isFetchingTimes = true
        const data = {
          start,
        }
        const endpoint = `/clinics/${this.company.slug}/appointments/${this.apptSession.id}`
        const resp = await this.$axios.patch(endpoint, data)
        this.$set(this.apptSession, 'start', start)
        this.$set(this.apptSession, 'preset_date', null)
        this.$set(this.apptSession, 'set_later', false)
        this.updateActivityLog(endpoint, data, resp, 'PATCH', this.apptSession.id)
        this.showMessage(['success', 'Appointment successfully booked and updated'])
      } catch (err) {
        let message = this.$t('error_message.unable_to_complete_request')
        if (err.response?.data?.detail) {
          message = err.response.data.detail
        }
        this.showMessage(['error', message])
        this.$set(this.apptSession, 'start', null)
        this.selectedTime = null
      } finally {
        this.isFetchingTimes = false
      }
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'appointment',
        activity: 'Set time for combo appointment',
        raw_data: { endpoint, payload, response: response.data, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
</style>